<template>
    <skutopia>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="3" sm="6">
                        <v-card flat>
                            <v-card-text>

                                <!-- Main Image -->
                                <v-img
                                :src="selectedImage.image"
                                max-width="100%"
                                class="main-image"
                                contain
                                v-if="selectedImage"
                                ></v-img>

                                <!-- Thumbnail Gallery -->
                                <v-card-text class="image-gallery-container pa-0">
                                    <div class="image-gallery">
                                    <v-img
                                        v-for="(image, index) in localProduct.images"
                                        :key="index"
                                        :src="image.thumbnail"
                                        max-height="75px"
                                        max-width="75px"
                                        class="thumbnail-image"
                                        @click="selectImage(image)"
                                        :class="{ 'selected': image === selectedImage }"
                                        contain
                                    ></v-img>
                                    </div>
                                </v-card-text>
                            </v-card-text>
                            </v-card>
                       
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-card flat class="ml-5">
                            <v-card-title>{{ localProduct.name }}
                                <v-spacer></v-spacer>
                                <v-btn 
                                    small
                                    color="primary"
                                    @click="editDialog = true"
                                    v-if="$can('add','skutopia')"
                                >
                                    Edit
                                </v-btn>
                            </v-card-title>
                            <v-card-text>
                                <table class="product-details-table" width="100vw">
                                <thead>
                                </thead>
                                <tbody>
                                    <tr>
                                    <td>{{ localProduct.barcode_type }}</td>
                                    <td>{{ localProduct.barcode }}</td>
                                    </tr>
                                    <tr v-if="localProduct.brand">
                                    <td>Brand</td>
                                    <td>{{ localProduct.brand.name }}</td>
                                    </tr>
                                    <tr v-if="localProduct.category">
                                    <td>Category</td>
                                    <td>{{ localProduct.category.name }}</td>
                                    </tr>
                                    <tr v-if="localProduct.market">
                                    <td>Market</td>
                                    <td>{{ localProduct.market.name }}</td>
                                    </tr>
                                    <!-- Add more rows as needed -->
                                </tbody>
                                </table>
                            </v-card-text>
                            <v-card-text>
                                <p><b>Description:</b> {{ localProduct.desc }}</p>
                                <p v-for="spec, index in localProduct.specs" :key="index">
                                    <b>{{ spec.specification }}:</b> {{ spec.value }}
                                </p>
                                <p><b>Height:</b> {{ displayDimension(localProduct.height) }}</p>
                                <p><b>Width:</b> {{ displayDimension(localProduct.width) }}</p>
                                <p><b>Weight:</b> {{ localProduct.weight }}</p>
                                <p><b>Projects:</b>
                                <v-chip-group>
                                    <v-chip v-for="project, index in localProduct.projects" :key="index"
                                         :to="{ name: 'project-view', params: { id: project } }"
                                    >{{ project }}</v-chip>
                                </v-chip-group></p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                
            </v-card-text>
        </v-card>
        <product
            :productDialog.sync="editDialog"
            :product="product"
            @save="saveProduct"
        >

        </product>

    </skutopia>
    
</template>

<script>
import { onMounted, ref, watch } from '@vue/composition-api'
import { useRouter } from '@core/utils'
import useProduct from '../useProduct'
import { mdiCheck } from '@mdi/js';
import Skutopia from '@/views/apps/skutopia/Skutopia.vue';
import Product from '../product-editor/ProductInfo.vue'

export default ({
    components:{
        Skutopia,
        Product
    },
    setup() { 
        
        
        const { route } = useRouter()

        const specsCounter = ref(0)
        const saveLoader = ref(false)
        const edit = ref(false)

        const placeholder = ref(`...`)

        const activeTab = ref('Attributes')
        const formImageData = ref({})

        const inStock = ref(true)
        const overlayOpen = ref(false)      // Controls visibility of the overlay dialog
        const selectedImage = ref(null)     // Stores the data of the currently selected image
        const localProduct =  ref({})

        const editDialog = ref(false)

        const {
            product,
            fetchProduct,
            updateProduct
        } = useProduct()

        const init = () => {
            formImageData.value = new FormData()
            // localProduct.value = {
            //     name:"",
            //     desc:"",
            //     barcode:"",
            //     barcode_type:"",
            //     categories:[],
            //     images:[],
            //     newImages:[],
            //     brand:null,
            //     market:null,
            //     tags:[],
            //     notes:"",
            //     innovation:"",
            //     width:"",
            //     height:"",
            //     depth:"",
            //     dimension_unit:"",
            //     weight:""

            // }
            localProduct.value = JSON.parse(JSON.stringify(product.value))
            selectedImage.value = localProduct.value.images[0]
        }

        
        if (route.value.params.id != 0) {

            localProduct.value = JSON.parse(JSON.stringify(product.value))
            localProduct.value['newImages'] = []
        }

        
        const selectImage = (image) => {
            selectedImage.value = image;
        };


        const displayDimension = (inValue) => {
            return `${(inValue * 2.54).toFixed(2)} cm / ${inValue} in`;
        }

        const saveProduct = async (sku) => {
            await updateProduct(sku)
        }


        onMounted(async () => {
            await fetchProduct(route.value.params.id)
        })

        watch(
            product,
            () => {
                init()
            }
        )

        return {
            product,
            localProduct,
            selectedImage,
            displayDimension,
            selectImage,
            editDialog,
            saveProduct,
            
            icons: {
                mdiCheck
            }
        }

    },
})
</script>

<style lang="scss" scoped>

.image-gallery-container {
  overflow: hidden;
}

.image-gallery {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  padding-right: 50px; /* Make room for the fade effect.  Needs to match the width of the pseudo-element */
  margin-right: -50px;  /* Counteract the added padding to maintain overall width */
}
.image-gallery::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 50px; /* Adjust the width of the fade effect */
  height: 100%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1)); /* Adjust colors if needed */
  pointer-events: none;
}

.main-image {
  margin-bottom: 20px;
  border: 1px solid #ccc;  /* Optional: Add a border for visual separation */
  border-radius: 4px;
}

.thumbnail-gallery {
  display: flex;
  overflow-x: auto; /* Enable horizontal scrolling */
  -webkit-overflow-scrolling: touch;  /* Smooth scrolling on iOS */
  padding-bottom: 10px; /* Added padding for scrollbar space */
}

.thumbnail-image {
  margin-right: 10px;
  cursor: pointer;
  border: 1px solid transparent; /* Initially transparent border */
  border-radius: 4px;
  transition: border-color 0.2s ease; /* Smooth transition for the border */
}

.thumbnail-image:hover {
  border-color: #999; /* Change border color on hover */
}

.thumbnail-image.selected {
  border-color: #007bff; /* Highlight the selected thumbnail */
}

/* Hide the scrollbar (optional) */
.thumbnail-gallery::-webkit-scrollbar {
  display: none;
}

.product-details-table {
  width: 100%; /* Make the table take up the full width */
}

/* Optional: Add some spacing and a subtle border */
.product-details-table td,
.product-details-table th {
  padding: 8px;
  border-bottom: 1px solid #eee;  /* Light grey border */
}

.product-details-table th {
  font-weight: bold;
}

</style>